module.exports = __webpack_public_path__ + "static/img/pro6_tab3.1798c46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro6_tab3.jpg
// module id = YA0X
// module chunks = 171